import React, { useState } from "react";
import styled from "styled-components";
import { Link } from 'react-router-dom';
import serix from "../assets/seriex.jpeg"
import vision from "../assets/vision.jpeg"
import moteur from "../assets/moteur.jpeg"
import video1 from "../assets/voltauto-x-series.mp4"
import video2 from "../assets/voltauto-vision.mp4"
import innovation from "../assets/innovation.mp4"

const projects = [
    {
        title: "VOLTAUTO X Series",
        image: serix,
        video: video1,
    },
    {
        title: "VOLTAUTO Vision",
        image: vision,
        video: video2,
    },
    {
        title: "Moteur Électrique Innovant",
        image: moteur,
        video: innovation,
    },
];

const ProjectsPage = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentVideo, setCurrentVideo] = useState("");

    // Fonction pour ouvrir la modale
    const openModal = (video) => {
        setCurrentVideo(video);
        setIsModalOpen(true);
    };

    // Fonction pour fermer la modale
    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentVideo("");
    };

    return (
        <Container>
            <Header>
                <Filter>All</Filter>
                <ViewToggle>+</ViewToggle>
                <GridToggle>⋮</GridToggle>
            </Header>

            <ProjectList>
                {projects.map((project, index) => (
                    <ProjectItem key={index}>
                        <ProjectInfo index={index}>
                            <ProjectTitle>{project.title}</ProjectTitle>
                            <ExploreLink onClick={() => openModal(project.video)}>
                                EXPLORE <Circle />
                            </ExploreLink>

                        </ProjectInfo>
                        <ProjectImage
                            src={project.image}
                            alt={project.title}
                            index={index} />

                    </ProjectItem>
                ))}
            </ProjectList>

 {/* Video  */}

            {isModalOpen && (
                <ModalOverlay>
                    <ModalContent>
                        <CloseButton onClick={closeModal}>X</CloseButton>
                        <VideoPlayer controls>
                            <source src={currentVideo} type="video/mp4" />
                            Votre navigateur ne supporte pas la vidéo.
                        </VideoPlayer>
                    </ModalContent>
                </ModalOverlay>
            )}

        </Container>
    );
};

export default ProjectsPage;

const Container = styled.div`
  padding: 2rem 4rem;
  min-height: 100vh;
  background: #fafafa;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  margin-bottom: 4rem;
`;

const Filter = styled.div`
  font-size: 1rem;
  cursor: pointer;
  flex: 1;
`;

const ViewToggle = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
`;

const GridToggle = styled(ViewToggle)`
  font-size: 1.2rem;
`;

const ProjectList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8rem;
  width: 100%;

  @media (max-width: 768px) {
    gap: 4rem;
  }
`;

const ProjectItem = styled.div`
  display: grid;
  grid-template-columns: 500px 400px; // Largeurs fixes
  gap: 4rem;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    max-width: 500px;
    margin: 0 auto;
  }
`;


const ProjectInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;


 // Animation d'entrée
 opacity: 0;
 transform: translateY(-50px);
 animation: slideDown 0.8s ease forwards;
 animation-delay: ${props => props.index * 0.3}s;

 @keyframes slideDown {
   from {
     opacity: 0;
     transform: translateY(-50px);
   }
   to {
     opacity: 1;
     transform: translateY(0);
   }
 }

`;

const ProjectTitle = styled.h2`
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 700;
  margin: 0;
`;

const ExploreLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #000;
  text-decoration: none;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: fit-content;
  padding: 8px 0;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #000;
    transform: scaleX(0);
    transform-origin: bottom right;
    transition: transform 0.3s ease;
  }

  &:hover:after {
    transform: scaleX(1);
    transform-origin: bottom left;
  }
`;

const Circle = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: #000;
  border-radius: 50%;
`;

const ProjectImage = styled.img`
 width: 400px;
 height: 400px; // Hauteur fixe pour l'effet
 aspect-ratio: 1;
 object-fit: cover;
 background: #eee;
 position: relative;
 clip-path: inset(0 0 100% 0);
 animation: revealImage 1s ease forwards;
 animation-delay: ${props => props.index * 0.3}s;

 @keyframes revealImage {
   from {
     clip-path: inset(0 0 100% 0);
   }
   to {
     clip-path: inset(0 0 0 0);
   }
 }

 @media (max-width: 1024px) {
   width: 100%;
   max-width: 400px;
   height: auto;
 }
`;


// Modal
const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    z-index: 1001;
`;

const ModalContent = styled.div`
   max-width: 90%;
   max-height: 95%;
   overflow: hidden;
   margin: 10px;

    @media (max-width: 768px) {
        max-width: 95%;
        max-height: auto;
        padding: 10px;
     
    }
`;

const CloseButton = styled.button`
    position: absolute;
  top: 10px;
  right: 20px;
  background-color: transparent;
  color: white;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 1100;
  
`;

const VideoPlayer = styled.video`
    width: 100%;
    height: 100%;
    object-fit: contain; /* Ensures video fits within container without distortion */

`;
